import { memo } from 'react';
import { clsx } from 'clsx';
import { HStack } from '@library';
import useProductQuantity from '../../queries/useProductQuantity';
import RestrictedContent from '../../../core/components/router/RestrictedContent';
import useLoginState from '../../../core/hooks/useLoginState';
import ProductQuantityControl from '../../../core/components/ProductQuantityControl';
import styles from './ProductTileActions.module.css';

export const ProductTileActionsContent = memo(
    ({
        activeSKU,
        maxQuantity,
    }: {
        activeSKU: string;
        maxQuantity?: number;
    }) => {
        const {
            quantity,
            updateQuantity,
            maxOrderQuantity,
            maxOrderQuantityLoading,
            loading,
        } = useProductQuantity({ sku: activeSKU });

        const isLoggedIn = useLoginState();

        if (maxOrderQuantity === 0) {
            return null;
        }

        return (
            <RestrictedContent
                storeFlags={isLoggedIn ? undefined : 'cartSharingEnabled'}
            >
                <ProductQuantityControl
                    mini
                    id="ProductTileQuantityInput"
                    value={quantity}
                    onChange={updateQuantity}
                    max={
                        maxQuantity !== undefined
                            ? maxQuantity
                            : maxOrderQuantity
                    }
                    loading={loading}
                    maxQuantityLoading={maxOrderQuantityLoading}
                />
            </RestrictedContent>
        );
    }
);

const ProductTileActions = ({
    activeSKU,
    maxQuantity,
    noMargin,
}: {
    activeSKU?: string;
    maxQuantity?: number;
    noMargin?: boolean;
}) => {
    if (activeSKU) {
        return (
            <div className={!noMargin ? styles.productTileActions : undefined}>
                <ProductTileActionsContent
                    activeSKU={activeSKU}
                    maxQuantity={maxQuantity}
                />
            </div>
        );
    }

    return (
        <HStack align="center" justify="spaceBetween">
            <div
                className={clsx(
                    styles.productTileActions,
                    styles.productTileActionsPlaceholder
                )}
            />
        </HStack>
    );
};

export default memo(ProductTileActions);
